import { render } from "./IconStripe.vue?vue&type=template&id=fafa0c88"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconStripe.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fafa0c88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fafa0c88', __exports__)) {
    api.reload('fafa0c88', __exports__)
  }
  
  module.hot.accept("./IconStripe.vue?vue&type=template&id=fafa0c88", () => {
    api.rerender('fafa0c88', render)
  })

}


export default __exports__